import { motiviOrdinati } from "@/lib/motiviBlocco";
import { nf } from "@/lib/panoramica";

interface PopoverMotiviProps {
  canale: string;
  recuperabili: number;
  inAuto: number;
  motivi: Record<string, number>;
}

export function PopoverMotivi({ canale, recuperabili, inAuto, motivi }: PopoverMotiviProps): JSX.Element {
  const righe = motiviOrdinati(motivi);
  return (
    <span className="block">
      <span className="flex items-baseline justify-between gap-2 border-b border-line pb-2">
        <span className="text-xs font-semibold text-ink">{canale}</span>
        <span className="font-mono text-xs font-semibold tabular-nums text-ink">{nf(recuperabili - inAuto)}</span>
      </span>
      <span className="mt-2 flex flex-col gap-1.5">
        {righe.length ? (
          righe.map((m) => (
            <span key={m.motivo} className="flex items-baseline justify-between gap-2.5">
              <span className="text-xs text-ink-2">{m.etichetta}</span>
              <span className="font-mono text-xs tabular-nums text-ink">{nf(m.n)}</span>
            </span>
          ))
        ) : (
          <span className="text-xs text-ink-3">Nessun blocco: vanno tutte in automatico.</span>
        )}
      </span>
      <span className="mt-2.5 block text-micro leading-snug text-ink-3">
        Su <span className="font-mono tabular-nums">{nf(recuperabili)}</span> recuperabili, <span className="font-mono tabular-nums">{nf(inAuto)}</span> sono già in auto. Motivi dal più frequente.
      </span>
    </span>
  );
}
